export default __webpack_public_path__ + "static/media/265.32135508.jpg";